import { axiosServices } from "./axiosServices";

export const categoryServices = {
  createtCategoryManagement,
  createSubCategory,
  getCategoryManagement,
  deleteCategory,
  deleteSubCategory,
  createDepartment,
  deleteDepartment,
  createRole,
  deleteRole,
  getCategoryList,
  getdepartments,
  getRolePermission,
  updateRolePermission,
};

function getCategoryList(param) {
  return axiosServices
    .getAxios(`/v1/admin/category-management/categories`)
    .then((res) => {
      return res;
    });
}

function createtCategoryManagement(param) {
  return axiosServices
    .postAxios(`/v1/admin/category-management/categories`, param)
    .then((res) => {
      return res;
    });
}
function createSubCategory(param, id) {
  return axiosServices
    .postAxios(
      `/v1/admin/category-management/categories/${id}/subcategories`,
      param
    )
    .then((res) => {
      return res;
    });
}
function getCategoryManagement(param) {
  return axiosServices.getAxios(`/v1/admin/category-management`).then((res) => {
    return res;
  });
}
function deleteCategory(id, param) {
  return axiosServices
    .deleteAxios(`/v1/admin/category-management/categories/${id}`, param)
    .then((res) => {
      return res;
    });
}
function deleteSubCategory(id, param) {
  return axiosServices
    .deleteAxios(`/v1/admin/category-management/subcategories/${id}`, param)
    .then((res) => {
      return res;
    });
}
function createDepartment(param) {
  return axiosServices
    .postAxios(`/v1/admin/category-management/departments`, param)
    .then((res) => {
      return res;
    });
}
function deleteDepartment(id, param) {
  return axiosServices
    .deleteAxios(`/v1/admin/category-management/departments/${id}`, param)
    .then((res) => {
      return res;
    });
}
function createRole(param, id) {
  return axiosServices
    .postAxios(`/v1/admin/category-management/roles`, param)
    .then((res) => {
      return res;
    });
}
function deleteRole(id, param) {
  return axiosServices
    .deleteAxios(`/v1/admin/category-management/roles/${id}`, param)
    .then((res) => {
      return res;
    });
}
function getdepartments(param) {
  return axiosServices
    .getAxios(`/v1/admin/category-management/departments`)
    .then((res) => {
      return res;
    });
}

function getRolePermission(id, param) {
  return axiosServices
    .getAxios(`/v1/admin/category-management/roles/${id}${param}`, param)
    .then((res) => {
      return res;
    });
}

function updateRolePermission(id, bodyData) {
  return axiosServices
    .patchAxios(`/v1/admin/category-management/roles/${id}/module`, bodyData)
    .then((res) => {
      return res;
    });
}
